import { useAirdropValueStore } from "@/modules/airdrop/store/value";
import { useUserStore } from "@/modules/auth/store/user";
import { formatNumber } from "@/modules/auth/utils/format";
import { constants } from "@/modules/calculations/consts";
import { useTranslation } from "react-i18next";

const AirdropBalance = () => {
  const { t } = useTranslation();

  const { airdrop, tonPrice, price, airdropBASE } = useUserStore();

  const { currentToken, net } = useAirdropValueStore();

  const toBTN = (tonAmount: number) => {
    if (!tonPrice || !price) return 0;
    return (tonAmount * tonPrice) / price;
  };

  const formatByUnit = (value: number) =>
    formatNumber(value, {
      precision:
        currentToken === "token" || currentToken === ""
          ? constants.TOKEN_DECIMALS
          : constants.TON_DECIMALS,
    });

  const tonAmount = Number(airdrop?.ton) || 0;

  const amount =
    net === "base"
      ? airdropBASE.token
      : currentToken === "token" || currentToken === ""
      ? toBTN(tonAmount)
      : tonAmount;

  return (
    <>
      <div className="flex w-full flex-col">
        <p className="p-4 pb-2 text-[0.8125rem] leading-[1rem] text-section-header-text tracking-tighter uppercase">
          {t("main-page.airdrop_balance")}
        </p>
        <div className="w-full flex items-center justify-between gap-4 px-4 bg-bg rounded-[0.75rem]">
          <div className="flex items-center gap-4">
            <div className="flex flex-col py-3 gap-0.5">
              <p className="text-[1.5rem] leading-[1.75rem] font-medium text-text">
                {formatByUnit(amount)}{" "}
                {currentToken === "token" || currentToken === "" || net === "base"
                  ? "BTN"
                  : "TON"}
              </p>
              <p className="text-[0.9375rem] leading-[1.25rem] text-subtitle-text">
                ≈ ${formatNumber(net === "ton" ? airdrop.usd : airdropBASE.usd, { precision: 5 })}
              </p>
            </div>
          </div>
        </div>
      </div>

      {currentToken === "ton" && net === "ton" && (
        <div className="flex w-full flex-col">
          <div className="flex items-center justify-between bg-bg rounded-[0.75rem] px-4 py-0.5">
            <p className="text-[1.0625rem] leading-[1.375rem] text-text py-3">
              {t("airdrop-page.transaction_fees")}
            </p>

            <p className="text-[1.0625rem] leading-[1.375rem] text-text">
              {formatNumber(airdrop.fee || 0, {
                precision: constants.TON_DECIMALS,
              })}{" "}
              TON
            </p>
          </div>
          <p className="px-4 pt-2 text-[0.8125rem] leading-[1rem] text-section-header-text tracking-tighter">
            {t("airdrop-page.transaction_paid")}
          </p>
        </div>
      )}
    </>
  );
};

export default AirdropBalance;
